import { RightOutlined } from '@ant-design/icons';
import { Link } from "react-router-dom"
import './style.css';


function Nav(props) {
    const {
        label,
        path,
        onClick,
        icon,
        iconColor = '#666',
        danger = false,
        style = {}
    } = props

    const content = (
        <>
            <div className="nav-content-left">
                {icon && (
                    <div className={`nav-icon-wrapper ${danger ? 'nav-icon-danger' : ''}`} 
                         style={{ '--icon-color': danger ? '#FF4757' : '#666' }}>
                        {icon}
                    </div>
                )}
                <span className={`nav-label ${danger ? 'nav-label-danger' : ''}`}>{label}</span>
            </div>
            <div className="nav-arrow">
                <RightOutlined />
            </div>
        </>
    );

    const className = `setting-tab ${danger ? 'setting-tab-danger' : ''}`;

    return (
        path ? (
            <Link to={path} style={{ ...style }} className={className}>
                {content}
            </Link>
        ) : (
            <div onClick={onClick} style={{ ...style }} className={className}>
                {content}
            </div>
        )
    )
}

export default Nav